import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeadset = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 14v-2a8 8 0 0 1 16 0v2" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 13,
			width: 4,
			height: 6,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.5,
			y: 13,
			width: 4,
			height: 6,
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("path", { d: "M20 19v1a3 3 0 0 1-3 3h-3" })
	]
});
export default SvgHeadset;
